const LengthUnitSpecification = {
  base: "M",
  factors: {
    M: 1,
    CM: 100
  }
};

export default LengthUnitSpecification;
